export default function authenticatedSignin({ to, next, store }) {

  if (store.getters['authentication/isUserLoggedIn']) {
    return next({ name: 'dashboard' })
  }

  next()
}
